import { AssetUIModel } from './global-utility.model';

export interface RelationModel {
  assets: AssetRelationsUIModel[];
  assetDetails: AssetUIModel[];
}

export interface AssetRelationsUIModel {
  assetId: string;
  relationTypes: RelationshipDetails[];
}

export interface RelationshipDetails {
  _id: string;
  name: string;
  description?: string;
}
